// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2E0GK","rootSmall":"AddTileButton_rootSmall__3RWvU"};